(() => {
  if (customElements.get('tl-sticky-purchase')) return;
  customElements.define('tl-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.info = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.info || this.info.closest('dialog, [role="dialog"]') || this.info.dataset.updateUrl !== 'true') { this.hidden = true; return; }
      this.form = this.info.querySelector('form[data-type="add-to-cart-form"]');
      this.source = this.form?.querySelector('button[name="add"]');
      this.price = this.info.querySelector(`#price-${this.dataset.section}`);
      this.button = this.querySelector('button');
      if (!this.source || !this.price) return;
      this.controller = new AbortController();
      this.button.addEventListener('click', () => {
        if (this.source.disabled || this.source.getAttribute('aria-disabled') === 'true') return;
        this.form.requestSubmit(this.source);
      }, { signal: this.controller.signal });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.source, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.observer.observe(this.price, { subtree: true, childList: true, characterData: true });
      this.visibility = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.pastPurchase = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.syncVisibility();
      });
      this.visibility.observe(this.source);
      this.media = matchMedia('(max-width: 989px)');
      this.media.addEventListener('change', () => this.syncVisibility(), { signal: this.controller.signal });
      this.sync();
    }
    sync() {
      this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.source.querySelector('span')?.textContent.trim() || this.dataset.addLabel;
      this.querySelector('[data-sticky-price]').textContent = this.price.textContent.trim().replace(/\s+/g, ' ');
      const choices = [...this.info.querySelectorAll('variant-selects input:checked')].map(input => input.value);
      this.querySelector('[data-sticky-options]').textContent = choices.join(' · ');
      this.syncVisibility();
    }
    syncVisibility() { this.hidden = !(this.media?.matches && this.pastPurchase); }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.visibility?.disconnect(); }
  });
})();
